export default "__VITE_ASSET__2wa3bd4S__"